import { BreadCrumbs as _Breadcrumbs } from '@carnica/ui-kit';
import PropTypes from 'prop-types';

import { enhancedConnect } from 'utils/lowCodeHelpers';

export const Breadcrumbs = enhancedConnect({
  items: PropTypes.string,
})(_Breadcrumbs);
